module.exports = __webpack_public_path__ + "media/luxury-2026/formal-exterior-f41f8cf6.jpg";